import { getApiServer } from './api'

/**
 * Mirror P1Web public/static/global/global.js API roots (minimal set).
 */
export function bootstrapApis () {
  const root = getApiServer()
  window.ApiServer = root
  window.DevSpecApi = root + '/DevSpecAPI/'
  window.DevTrackApi = root + '/DevTrackApi/api/'
  window.DevTestApi = root + '/DevTestApi/api/'
  window.P1AdminApi = root + '/P1AdminAPI/api/'
  window.APIToken = window.APIToken || '8d4b0a25-56e5-40ab-aa6b-ae7b09b74f7f'
  window.Auth = 'Bearer ' + window.APIToken
  window.LivedocApi = window.LivedocApi || 'https://livedoc.peertime.cn/TxLiveDocumentApi/api/'
  window.LivedocApiToken = window.LivedocApiToken || '02912174-3dcb-49eb-b9fa-6d90b390d495'
  window.EnableSessionAuth = 0
  if (typeof globalThis !== 'undefined') {
    globalThis.DevSpecApi = window.DevSpecApi
    globalThis.DevTrackApi = window.DevTrackApi
  }
}

export function refreshApiRoots () {
  bootstrapApis()
}
